module.exports = __webpack_public_path__ + "static/media/car.8aace450.jpg";